import React, { useState } from 'react';
import Contents from '../../../contents/index';
import axios from 'axios';
import SectionSubject from './section_subject';
import SectionDate from './section_date';
import SectionIsApplicationAllowed from './section_is_application_allowed';
import SectionAmount from './section_amount';
import SectionPlans from './section_plans';
import SectionIsPublicity from './section_is_publicity';

const Edit = ({
  companyId,
  crafan,
  prevCrafansPlans,
  isApp,
  mainImageUrl,
  userAgent,
  isNew
}) => {
  const [title, setTitle] = useState(crafan.title);
  const [titleError, setTitleError] = useState(false);
  const [startedAt, setStartedAt] = useState(crafan.started_at);
  const [expiredAt, setExpiredAt] = useState(crafan.expired_at);
  const [targetAmount, setTargetAmount] = useState(crafan.target_amount);
  const [limitAmount, setLimitAmount] = useState(crafan.limit_amount);
  const [limitError, setLimitError] = useState(false);
  const [isApplicationAllowed, setIsApplicationAllowed] = useState(
    crafan.is_application_allowed
  );
  const [isPublicity, setIsPublicity] = useState(crafan.is_publicity);
  const [image, setImage] = useState(mainImageUrl);
  const [crafansPlans, setCrafansPlans] = useState(prevCrafansPlans);

  const updateImage = React.useCallback(
    photoFile => {
      let formData = new FormData();
      formData.append('file', photoFile);
      axios
        .patch(
          `/api/community/${companyId}/crafans/${crafan.id}/update_image`,
          formData
        )
        .then(response => {
          setImage(response.data.main_image_url);
        })
        .catch(() => {});
    },
    [crafan]
  );

  const handleSubmitButton = () => {
    if (!title.trim()) {
      setTitleError(true);
      return;
    }
    setTitleError(false);
  
    if (!limitAmount.trim()) {
      setLimitError(true);
    } else {
      setLimitError(false);
    }
    if (!title.trim() || !limitAmount.trim()) return;

    var result = window.confirm(
      `プロジェクトを${isNew ? '作成' : '更新'}しますか？`
    );
    if (result) {
      axios
        .post(`/api/community/${companyId}/crafans/${crafan.id}/update`, {
          id: crafan.id,
          title: title,
          started_at: startedAt,
          expired_at: expiredAt,
          target_amount: targetAmount,
          limit_amount: limitAmount,
          is_publicity: isPublicity,
          is_application_allowed: isApplicationAllowed
        })
        .then(() => {
          window.location.href = `/community/${companyId}/admin/crafans/`;
        })
        .catch(() => {});
    }
  };

  return (
    <main className="bg-gray h-100 min-vh-100">
      <div className="container col-md-8 col-lg-6 mt-5">
        <figure style={{ position: 'relative' }}>
          <label htmlFor="image_data" className="w-100">
            {image ? (
              <img
                src={image}
                alt="Crafan main image"
                style={{ height: '400px', width: '100%', objectFit: 'cover' }}
              />
            ) : (
              <span className="d-block text-black-20 text-fz-small">
                <img
                  src="/assets2019/image.svg"
                  alt=""
                  className="cursor-pointer logo-img-circle bg-graydark"
                  style={{ width: '70px', height: '70px' }}
                />
              </span>
            )}
            <input
              type="file"
              accept="image/png, image/jpeg"
              onChange={e => {
                updateImage(e.target.files[0]);
              }}
              id="image_data"
              style={{ display: 'none' }}
            />
          </label>
        </figure>
      </div>
      <SectionSubject title={title} setTitle={setTitle} titleError={titleError} setTitleError={setTitleError} />
      <SectionDate
        startedAt={startedAt}
        setStartedAt={setStartedAt}
        expiredAt={expiredAt}
        setExpiredAt={setExpiredAt}
      />
      <SectionAmount
        targetAmount={targetAmount}
        setTargetAmount={setTargetAmount}
        limitAmount={limitAmount}
        setLimitAmount={setLimitAmount}
        limitError={limitError}
        setLimitError={setLimitError}
      />
      <SectionIsPublicity 
        isPublicity={isPublicity}
        setIsPublicity={setIsPublicity}
      />
      <SectionIsApplicationAllowed
        isApplicationAllowed={isApplicationAllowed}
        setIsApplicationAllowed={setIsApplicationAllowed}
      />
      <SectionPlans
        companyId={companyId}
        crafanId={crafan.id}
        crafansPlans={crafansPlans}
        setCrafansPlans={setCrafansPlans}
        isNew={isNew}
      />
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          プロジェクトの詳細
        </p>
      </div>
      <Contents
        foreignKeyId={crafan.id}
        isApp={isApp}
        userAgent={userAgent}
        model={'Crafan'}
      />
      <div className="container col-md-8 col-lg-6 mt-5 pb-5">
        <div
          className="w-100"
          style={{ paddingRight: '10px', paddingLeft: '10px' }}
        >
          <button
            type="button"
            className="mx-1 a-button a-button__top a-button--orange w-100 mb-3"
            onClick={handleSubmitButton}
          >
            {isNew ? 'プロジェクトを作成' : 'プロジェクトを更新'}
          </button>
        </div>
      </div>
    </main>
  );
};

export default Edit;
